import { apiFetch } from '../utils/api';

export interface Country {
  id: string;
  erpId: number;
  name: string;
  iso2: string | null;
  iso3: string | null;
  phoneCode: string | null;
  region: string | null;
  subregion: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface PaginatedCountriesResponse {
  data: Country[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

interface FetchCountriesParams {
  page?: number;
  limit?: number;
  search?: string;
}

export const fetchCountries = (
  params: FetchCountriesParams = {},
): Promise<PaginatedCountriesResponse> => {
  const searchParams = new URLSearchParams();

  if (params.page) {
    searchParams.set('page', String(params.page));
  }

  if (params.limit) {
    searchParams.set('limit', String(params.limit));
  }

  if (params.search) {
    searchParams.set('search', params.search);
  }

  const query = searchParams.toString();
  return apiFetch<PaginatedCountriesResponse>(`/countries${query ? `?${query}` : ''}`);
};

export const syncCountriesFromErp = (): Promise<{ syncedCount: number; statusCode: number }> => {
  return apiFetch<{ syncedCount: number; statusCode: number }>(`/countries/sync-from-erp`, {
    method: 'POST',
  });
};

export const fetchAllCountries = (): Promise<Country[]> => {
  return apiFetch<Country[]>(`/countries/all`);
};
